<template>
    <div class="page-content" id="priceControlBoard">
        <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
            <el-breadcrumb-item>控价数据看板</el-breadcrumb-item>
        </el-breadcrumb>
        <section class="seaerch-wrapper">
            <el-form class="search-form">
                <el-form-item label="日期" label-width="100px">
                    <el-date-picker
                        size="small"
                        value-format="yyyy-MM-dd"
                        v-model="searchformDate"
                        type="daterange"
                        range-separator="~"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 100%;"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label-width="100px">
                    <el-button size="small" class="search-btn" plain @click="theQuery()">查询</el-button>
                </el-form-item>
            </el-form>
        </section>
        <el-row>
            <el-col :span="8">
                <div style="margin: 16px 16px 16px 0px;background-color: white;float: left;width: calc(100% - 16px);">
                    <img src="../../../assets/img/icon-clcg@2x.png" style="height: 60px;width: 60px;padding: 20px 30px;float: left;">
                    <div style="color: #2E2E3A;font-size: 16px;padding-top: 20px;">
                        处理成功数
                    </div>
                    <div style="color: #2E2E3A;font-size: 16px;padding-top: 13px;" v-if="form.retrieveDataCountList">
                        {{ form.retrieveDataCountList[0].noticepriceok }}
                    </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div style="margin: 16px 16px 16px 0;background-color: white;float: left;width: calc(100% - 16px);">
                    <img src="../../../assets/img/icon-clzl@2x.png" style="height: 60px;width: 60px;padding: 20px 30px;float: left;">
                    <div style="color: #2E2E3A;font-size: 16px;padding-top: 20px;">
                        处理总量
                    </div>
                    <div style="color: #2E2E3A;font-size: 16px;padding-top: 13px;" v-if="form.retrieveDataCountList">
                        {{ form.retrieveDataCountList[0].totalamount }}
                    </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div style="margin: 16px 0px 16px 0px;background-color: white;float: left;width: 100%;">
                    <img src="../../../assets/img/icon-cgl@2x.png" style="height: 60px;width: 60px;padding: 20px 30px;float: left;">
                    <div style="color: #2E2E3A;font-size: 16px;padding-top: 20px;">
                        处理成功率
                    </div>
                    <div style="color: #2E2E3A;font-size: 16px;padding-top: 13px;" v-if="form.retrieveDataCountList">
                        {{ form.retrieveDataCountList[0].successrate }}
                    </div>
                </div>
            </el-col>

            <el-col :span="12" style="margin-bottom: 16px;clear: both;">
                <div style="font-size: 16px;color: #333333;display: flex;">
                    <div class="iconDiv-priceControlBoard">
                        .
                    </div>
                    处理总量和处理成功率变化趋势
                </div>
            </el-col>
            <el-col :span="12" style="margin-bottom: 16px;">
                <div style="font-size: 16px;color: #333333;display: flex;">
                    <div class="iconDiv-priceControlBoard">
                        .
                    </div>
                    处理总量和处理成功率平台分布
                </div>
            </el-col>

            <el-col :span="12" style="margin-bottom: 16px;">
                <div id="main" style="height: 373px;width: calc(100% - 16px);background-color: white;margin-right: 16px;padding-top: 16px;"></div>
            </el-col>
            <el-col :span="12" style="margin-bottom: 16px;">
                <div id="main2" style="height: 373px;width: 100%;background-color: white;padding-top: 16px;"></div>
            </el-col>

            <el-col :span="24" style="margin-bottom: 16px;clear: both;">
                <div style="font-size: 16px;color: #333333;display: flex;">
                    <div class="iconDiv-priceControlBoard">
                        .
                    </div>
                    经销商违规情况
                    <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        content="仅展示处理总量 排名前10的数据">
                        <i slot="reference" class="el-icon-warning-outline" style="margin-left: 5px;"></i>
                    </el-popover>
                </div>
            </el-col>
            <el-col :span="24" style="margin-bottom: 16px;">
                <div style="width: calc(100% - 38px);background-color: white;margin-right: 16px;padding: 11px;">
                    <el-table :data="form.dealerSortListTop.dealerSortListTop" v-if="form.dealerSortListTop">
                        <el-table-column prop="dealername" label="经销商名称" width="300"></el-table-column>
                        <el-table-column :label="item.name" v-for="item in form.dealerSortListTop.platformAxis">
                            <template slot-scope="scope">
                                {{ scope.row[item.value] ? scope.row[item.value] : 0}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalamount" label="总和"></el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :span="24" style="margin-bottom: 16px;">
                <div style="font-size: 16px;color: #333333;display: flex;">
                    <div class="iconDiv-priceControlBoard">
                        .
                    </div>
                    经销商整改情况
                    <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        content="仅展示处理总量 排名前10的数据">
                        <i slot="reference" class="el-icon-warning-outline" style="margin-left: 5px;"></i>
                    </el-popover>
                </div>
            </el-col>
            <el-col :span="24" style="margin-bottom: 16px;">
                <div style="width: calc(100% - 22px);background-color: white;padding: 11px;">
                    <el-table :data="form.retrieveDataDealerRate">
                        <el-table-column prop="dealername" label="经销商名称" width="400px"></el-table-column>
                        <el-table-column prop="pricechange" label="已改价"></el-table-column>
                        <el-table-column prop="takedown" label="已下架"></el-table-column>
                        <el-table-column prop="totalamount" label="已通知"></el-table-column>
                        <el-table-column prop="successrate" label="处理成功率"></el-table-column>
                    </el-table>
                </div>
            </el-col>

            <el-col :span="24" style="margin-bottom: 16px;clear: both;">
                <div style="font-size: 16px;color: #333333;display: flex;">
                    <div class="iconDiv-priceControlBoard">
                        .
                    </div>
                    白名单店铺违规情况
                    <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        content="仅展示处理总量 排名前10的数据">
                        <i slot="reference" class="el-icon-warning-outline" style="margin-left: 5px;"></i>
                    </el-popover>
                </div>
            </el-col>
            <el-col :span="24" style="margin-bottom: 16px;">
                <div style="width: calc(100% - 38px);background-color: white;margin-right: 16px;padding: 11px;">
                    <el-table :data="form.shopASortMap.shopASortListTop" v-if="form.shopASortMap">
                        <el-table-column prop="shopname" label="店铺名称" width="300"></el-table-column>
                        <el-table-column :label="item.name" v-for="item in form.shopASortMap.platformShopAccreditAxis">
                            <template slot-scope="scope">
                                {{ scope.row[item.value] ? scope.row[item.value] : 0 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalamount" label="总和"></el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :span="24" style="margin-bottom: 16px;">
                <div style="font-size: 16px;color: #333333;display: flex;">
                    <div class="iconDiv-priceControlBoard">
                        .
                    </div>
                    非白名单店铺违规情况
                    <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        content="仅展示处理总量 排名前10的数据">
                        <i slot="reference" class="el-icon-warning-outline" style="margin-left: 5px;"></i>
                    </el-popover>
                </div>
            </el-col>
            <el-col :span="24" style="margin-bottom: 16px;">
                <div style="width: calc(100% - 22px);background-color: white;padding: 11px;">
                    <el-table :data="form.shopBSortMap.shopBSortListTop" v-if="form.shopBSortMap">
                        <el-table-column prop="shopname" label="店铺名称" width="300"></el-table-column>
                        <el-table-column :label="item.name" v-for="item in form.shopBSortMap.platformShopBccreditAxis">
                            <template slot-scope="scope">
                                {{ scope.row[item.value] ? scope.row[item.value] : 0 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalamount" label="总和"></el-table-column>
                    </el-table>
                </div>
            </el-col>

            <el-col :span="24" style="margin-bottom: 16px;">
                <div style="font-size: 16px;color: #333333;display: flex;">
                    <div class="iconDiv-priceControlBoard">
                        .
                    </div>
                    产品类目违规情况
                    <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        content="仅展示处理总量 排名前10的数据">
                        <i slot="reference" class="el-icon-warning-outline" style="margin-left: 5px;"></i>
                    </el-popover>
                </div>
            </el-col>
            <el-col :span="24" style="margin-bottom: 16px;">
                <div id="main3" style="height: 329px;width: calc(100% - 32px);background-color: white;padding: 16px;"></div>
            </el-col>
        </el-row>
    </div>
  </template>
  <script>
    export default {
      data() {
        return {
            searchformDate: [],
            tableLoading: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            form: {},
        };
      },
      mounted() {
        this.searchformDate = this.getNowTime()
        this.theQuery()
      },
      methods: {
        getNowTime() {
            let that=this
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            // end.setTime(start.getTime() + 3600 * 1000 * 24 * 6);
            let startTime= that.formatDate(start);
            let endTime = that.formatDate(end);
            return [startTime, endTime]
        },
        // 时间格式化
        formatDate(date) {
            var myyear = date.getFullYear();
            var mymonth = date.getMonth() + 1;
            var myweekday = date.getDate();
            if (mymonth < 10) {
                mymonth = "0" + mymonth;
            }
            if (myweekday < 10) {
                myweekday = "0" + myweekday;
            }
            return (
                myyear + "-" + mymonth + "-" + myweekday
            );
        },
        theQuery() {
            this.tableLoading = true
            let params={
                begintime: this.searchformDate[0],
                endtime: this.searchformDate[1],
            }
            fetch({
                url: "hcm/iprViolationRetrieveData/dataAnalysis",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then(result => {
                let res = JSON.parse(result);
                let {data}=res
                if(res.status == '10000'){
                    this.form = res.data
                    this.drawChart(res.data.retrieveDataSeries[0])
                    this.drawChart2(res.data.retrieveDataPlatformMap)
                    this.drawChart3(res.data.retrieveDataProduct)
                }
            })
        },
        // 处理总量和处理成功率平台分布
        drawChart(retrieveDataSeries) {
            // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
            let myChart = this.$echarts.init(document.getElementById("main"));
            // 指定图表的配置项和数据
            let option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ["处理总量","处理成功率"],
                    textStyle: {
                        color: '#66687C',   // 设置图例文本颜色
                    }
                },
                xAxis: {
                    type: 'category',
                    data: retrieveDataSeries.Axis,
                    axisPointer: {
                        type: 'shadow'
                    },
                    axisLabel: {
                        color: "#66687C",
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#66687C'   // 将刻度线颜色修改为红色
                        }
                    },
                },
                yAxis: [{
                    type: 'value',
                    splitLine:{
                        show:false // 不显示网格线
                    },
                    axisLabel: {
                        formatter: '{value}',
                        color: "#66687C",
                    }
                },{
                    type: 'value',
                    splitLine:{
                        show:false // 不显示网格线
                    },
                    axisLabel: {
                        formatter: '{value} %',
                        color: "#66687C",
                    }
                }],
                series: [{
                    name: '处理总量',
                    type: 'bar',
                    barWidth : 20,
                    color: '#0164FF',
                    data: retrieveDataSeries.datatotal,
                    yAxisIndex: 0,
                },{
                    name: '处理成功率',
                    type: 'line',
                    barWidth : 20,
                    color: '#F7B500',
                    data: retrieveDataSeries.datarate,
                    yAxisIndex: 1,
                    tooltip: {
                        valueFormatter: function (value) {
                            return value + ' %';
                        }
                    },
                }]
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        // 处理总量和处理成功率平台分布
        drawChart2(retrieveDataPlatformMap) {
            // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
            let myChart = this.$echarts.init(document.getElementById("main2"));
            // 指定图表的配置项和数据
            let option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ["处理总量","处理成功率"],
                    textStyle: {
                        color: '#66687C',   // 设置图例文本颜色
                    }
                },
                xAxis: {
                    type: 'category',
                    data: retrieveDataPlatformMap.yAxisAll,
                    axisPointer: {
                        type: 'shadow'
                    },
                    axisLabel: {
                        color: "#66687C",
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#66687C'   // 将刻度线颜色修改为红色
                        }
                    },
                },
                yAxis: [{
                    type: 'value',
                    splitLine:{
                        show:false // 不显示网格线
                    },
                    axisLabel: {
                        formatter: '{value}',
                        color: "#66687C",
                    }
                },{
                    type: 'value',
                    splitLine:{
                        show:false // 不显示网格线
                    },
                    axisLabel: {
                        formatter: '{value} %',
                        color: "#66687C",
                    }
                }],
                series: [{
                    name: '处理总量',
                    type: 'bar',
                    barWidth : 20,
                    color: '#409EFF',
                    data: retrieveDataPlatformMap.series,
                    yAxisIndex: 0,
                },{
                    name: '处理成功率',
                    type: 'bar',
                    barWidth : 20,
                    color: '#BEDAFF',
                    data: retrieveDataPlatformMap.seriesrate,
                    yAxisIndex: 1,
                    tooltip: {
                        valueFormatter: function (value) {
                            return value + ' %';
                        }
                    },
                }]
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        // 产品类目违规情况
        drawChart3(retrieveDataProduct) {
            // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
            let myChart = this.$echarts.init(document.getElementById("main3"));
            let option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                color: ['#7F9CFF', '#74BE8C', '#CBE1FF', '#D7E9FF', '#BFB3FF', '#3F92FE', '#F7B500', '#67C23A', '#E6A23C', '#F56C6C'],
                series: [{
                    type: 'treemap',
                    data: retrieveDataProduct,
                }]
            }
            myChart.setOption(option);
        },
      }
    };
  </script>
    <style>
    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }
    .el-table th {
        background-color: #f2f6fe !important;
        color: #4a4b4c;
    }
    </style>
  <style lang="scss" scoped>
    .iconDiv-priceControlBoard {
        width: 5px;
        background-color: #333333;
        margin-right: 10px;
        height: 21px;
    }
   
  </style>
  